import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "slot-product"
}
const _hoisted_2 = { class: "slot-info" }
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = {
  key: 0,
  class: "connection-user"
}
const _hoisted_6 = { class: "staff-avatar" }
const _hoisted_7 = { class: "min-w-0" }
const _hoisted_8 = { class: "text-sm font-medium" }
const _hoisted_9 = { class: "text-xs text-muted-foreground mt-1" }

import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { PlugZap, Server, UserRound } from '@lucide/vue';

import { ref } from 'vue';
import axios from 'axios';
import moment from 'moment';
import { ConnectionSlotState } from '../models/saas_extension';
import ConnectionQueue from './ConnectionQueue.vue';
import { useMainStore } from '@/store';

interface Props {
  connSlot: Slot;
  queue: Queue[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SlotDetail',
  props: {
    connSlot: {},
    queue: {}
  },
  emits: ['slotChanged'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useMainStore();
const loading = ref(false);

function connectionStateToTakeSlotButtonText(value: ConnectionSlotState): string {
  switch (value) {
    case ConnectionSlotState.Ready:
      return 'Занять';
    case ConnectionSlotState.BusyByAnotherUser:
      return 'В очередь';
    case ConnectionSlotState.BusyByCurrentUser:
      return 'Освободить';
    default:
      return '';
  }
}

function slotQueue() {
  const filtered = props.queue
    .filter(
      (q) =>
        q.property === props.connSlot.property_id &&
        (q.product === null || q.product == props.connSlot.product_id)
    )
    .sort((x, y) => (x.date_created > y.date_created ? 1 : 0));
  return filtered;
}

function getSlotState(): ConnectionSlotState {
  if (props.connSlot.connection != null) {
    if (props.connSlot.connection.user.username == store.currentUserName) {
      return ConnectionSlotState.BusyByCurrentUser;
    }
    return ConnectionSlotState.BusyByAnotherUser;
  } else {
    return ConnectionSlotState.Ready;
  }
}

function getUserInitials(): string {
  if (!props.connSlot.connection) return '';
  const username = props.connSlot.connection.user.username;
  return username.substring(0, 2).toUpperCase();
}

function formatDateTime(dateTime: string): string {
  return moment(dateTime).format('DD.MM.YYYY HH:mm');
}

async function changeSlotState() {
  loading.value = true;
  const state = getSlotState();
  switch (state) {
    case ConnectionSlotState.Ready:
    case ConnectionSlotState.BusyByAnotherUser:
      await axios.post('/api/slots/' + props.connSlot.id + '/take/').then(
        (response) => {
          if (response.status == 201 && state == ConnectionSlotState.Ready) {
            emit('slotChanged');
          }
          loading.value = false;
        },
        (_error) => {
          loading.value = false;
        }
      );
      break;
    case ConnectionSlotState.BusyByCurrentUser:
      await axios.post('/api/slots/' + props.connSlot.id + '/release/').then(
        (response) => {
          if (response.status == 201) {
            emit('slotChanged');
          }
          loading.value = false;
        },
        (_error) => {
          loading.value = false;
        }
      );
      break;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "slot-card" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), { class: "slot-header" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Badge), {
            variant: getSlotState() === 0 ? 'secondary' : 'outline'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.connSlot.type), 1)
            ]),
            _: 1
          }, 8, ["variant"]),
          (__props.connSlot.product)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.connSlot.product), 1))
            : _createCommentVNode("", true),
          _createVNode(_unref(Button), {
            size: "sm",
            variant: "outline",
            disabled: loading.value,
            class: "ml-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSlotState()))
          }, {
            default: _withCtx(() => [
              (loading.value)
                ? (_openBlock(), _createBlock(_unref(Spinner), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(PlugZap), {
                    key: 1,
                    size: 14
                  })),
              _createTextVNode(" " + _toDisplayString(connectionStateToTakeSlotButtonText(getSlotState())), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(_unref(CardContent), { class: "space-y-3" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Server), {
                size: 14,
                class: "info-icon"
              }),
              _createElementVNode("span", null, _toDisplayString(__props.connSlot.server_address), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(UserRound), {
                size: 14,
                class: "info-icon"
              }),
              _createElementVNode("span", null, _toDisplayString(__props.connSlot.account), 1)
            ])
          ]),
          (__props.connSlot.connection)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(getUserInitials()), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(__props.connSlot.connection.user.username), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(formatDateTime(__props.connSlot.connection.date_started)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(ConnectionQueue, {
        queue: slotQueue()
      }, null, 8, ["queue"])
    ]),
    _: 1
  }))
}
}

})